import type { Nullable } from '@shared/models/types/primary'

import { Conversation as ConversationPC } from '@protos/apps/pc/conversation_pb'
import { Conversation as ConversationVC } from '@protos/apps/vc/conversation_pb'
import { Participant } from '@protos/chat/participant_pb'
import { UserType } from '@protos/user_type_pb'

export const isBotConversation = (
  conversation: Nullable<ConversationPC | ConversationVC>,
  charUserId: number
): boolean => {
  // const message = messages.find((msg) => msg.id === data.messageId);

  if (conversation) {
    const participant = conversation.participants.find(
      (value: Participant) => value.chatUserId === charUserId
    )

    return participant?.type === UserType.BOT
  }

  return false
}
